import { Link, useLocation, useParams } from 'react-router-dom';
import { BarChart2, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/core/lib/utils';
import { useSidebar } from '@/core/hooks/useSidebar';
import { OrganizationSwitcher } from '../../OrganizationSwitcher';

export function AnalyticsPanel() {
  const { t } = useTranslation('layout');
  const { orgId } = useParams<{ orgId: string }>();
  const { pathname } = useLocation();
  const { closeMobile, isMobile } = useSidebar();

  const isOrgSummaryActive = pathname.startsWith(`/${orgId}/analytics`);
  const isMySummaryActive = pathname.startsWith(`/${orgId}/personal-summary`);

  return (
    <>
      {/* Personal section */}
      <div className="px-3 pt-5 pb-3 shrink-0">
        <p className="text-sm font-semibold text-muted-foreground tracking-widest px-2 mb-2">
          {t('sidebar.analytics.title')}
        </p>
        <nav className="flex flex-col gap-0.5">
          <Link
            to={`/${orgId}/personal-summary`}
            onClick={() => isMobile && closeMobile()}
            className={cn(
              'flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors',
              isMySummaryActive
                ? 'bg-primary/10 text-primary font-medium'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            <User className="w-4 h-4 shrink-0" />
            {t('sidebar.analytics.mySummary')}
          </Link>
        </nav>
      </div>

      <div className="mx-3 border-t border-border shrink-0" />

      {/* Org switcher */}
      <OrganizationSwitcher />

      {/* Organization section */}
      <div className="px-3 pb-3 shrink-0">
        <nav className="flex flex-col gap-0.5">
          <Link
            to={`/${orgId}/analytics`}
            onClick={() => isMobile && closeMobile()}
            className={cn(
              'flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors',
              isOrgSummaryActive
                ? 'bg-primary/10 text-primary font-medium'
                : 'text-muted-foreground hover:bg-muted hover:text-foreground',
            )}
          >
            <BarChart2 className="w-4 h-4 shrink-0" />
            {t('sidebar.analytics.orgSummary')}
          </Link>
        </nav>
      </div>
    </>
  );
}
